import O1HD from "../../../../engines/gameEngine";
import { BUNDLE_SMALL_NAME, getOneBundleByInstant } from "../../BundleResourceConfig";
import { getOneChitAryById } from "../../config/WeChatChitChatConfig";
import { getOnePeopleById } from "../../config/WeChatPeopleConfig";
import { WeChatChitChatChoose, WeChatLink, WeChatManagerPeople } from "../../manager/WeChatConst";
import WeChatManager from "../../manager/WeChatManager";
import WeChatFrame from "./WeChatFrame";

const {ccclass, property} = cc._decorator;

@ccclass
export default class WeChatMainItem extends cc.Component {

    @property({type:cc.Node,displayName:"头像节点"})
    headSp:cc.Node = null;

    @property({type:cc.Node,displayName:"红色提醒节点"})
    redCircle:cc.Node = null;

    @property({type:cc.Label,displayName:"名字文本"})
    lb_Name:cc.Label = null;

    @property({type:cc.Label,displayName:"字文本"})
    lb_Chat:cc.Label = null;

    @property({type:cc.Prefab,displayName:"chatFramePrefab"})
    chatFramePrefab:cc.Prefab = null;

    people:WeChatManagerPeople = null;

    manager:WeChatManager = null;

    setData(people:WeChatManagerPeople,manager:WeChatManager){
        this.manager = manager;
        this.people = people;
        this.updateItem();
    }

    updateItem(){
        if(this.people){
            let people = getOnePeopleById(this.people.peopleId);
            let lastChitChat = this.people.peopleChatLastLink;
            let chitChatQueue = this.people.peopleChatLinkQueue;
            let smallChat:string = "";
            // console.log(people,chitChatQueue);
            if(chitChatQueue.length > 0){
                // 如果队列中有需要聊天的事件 则显示聊天的事件 小红点显示
                this.redCircle.active = true;
            } else {
                this.redCircle.active = false;
            }
            if( this.people.bNewChat && chitChatQueue.length > 0){
            // if(chitChatQueue.length > 0){
                // 如果队列中有需要聊天的事件 则显示聊天的事件 小红点显示
                // this.redCircle.active = true;
                let chitChat = getOneChitAryById(chitChatQueue[0]);
                let chatChooseData = chitChat.chats[0].chooses[0];
                smallChat = chatChooseData.chat;
                if(smallChat.includes("红包：")){
                    smallChat = "[红包]";
                }else if(smallChat.includes("转账：")){
                    smallChat = "[转账]";
                }else if(smallChat.includes("图片：")){
                    smallChat = "[图片]";
                }else{
                    if (chatChooseData.param && chatChooseData.param.goods && chatChooseData.param.goods.length > 0) {
                        smallChat = "[物品]";
                    } else {
                        smallChat = smallChat;
                    }
                }
            }else{
                // 如果队列中没有需要聊天的事件 则显示最后一个聊天的事件  小红点隐藏
                // this.redCircle.active = false;
                let lastChatData = lastChitChat[lastChitChat.length - 1];
                let chitChat = getOneChitAryById(lastChatData.chatsId);
                let lastChonse: WeChatChitChatChoose = null;
                for (let o of chitChat.chats) {
                    if (o.id == lastChatData.chatId) {
                        lastChonse = o.chooses[lastChatData.chatChoose];
                        break;
                    }
                }
                let last = lastChonse && lastChonse.chat || '';
                if(last.includes("红包：")){
                    smallChat = "[红包]";
                }else if(last.includes("转账：")){
                    smallChat = "[转账]";
                }else if(last.includes("图片：")){
                    smallChat = "[图片]";
                }else{
                    if (lastChonse && lastChonse.param && lastChonse.param.goods && lastChonse.param.goods.length > 0) {
                        smallChat = "[物品]";
                    } else {
                        smallChat = last;
                    }
                }
                // 图片待定
                // smallChat = chitChat[ chitChat.length - 1 ].chooses[0].chat;
            }

            if (!people) {
                console.error('出错了 peopleId = ', this.people.peopleId);
            }
            this.lb_Name.string = people.name;
            this.setChatStr(smallChat);
            this.loadHeadSp();
        }
    }

    //加载头像
    loadHeadSp(){
        let people = getOnePeopleById(this.people.peopleId);
        let headUrl = people.headUrl;
        //  加载一个头像
        getOneBundleByInstant(BUNDLE_SMALL_NAME.WeChatGameBundle).load(headUrl,cc.SpriteFrame,(err,assets:cc.SpriteFrame)=>{
            if(err){
                console.log("加载头像失败!!!!!");
            }else{
                if(this.headSp&&this.headSp.isValid)
                {
                    this.headSp.getComponent(cc.Sprite).spriteFrame = assets;   
                }
            }
        })
    }
    
    setChatStr(str:string){
        if(str.length > 15){
            str = str.substring(0,15) + "......";
        }else{
            str = str;
        }
        this.lb_Chat.string = str;
    }

    onBtnMe(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        let lastChitChat = this.people.peopleChatLastLink;
        let chitChatQueue = this.people.peopleChatLinkQueue;
        let chatFrame = cc.instantiate(this.chatFramePrefab);
        let cs = chatFrame.getComponent(WeChatFrame);
        if((!lastChitChat || lastChitChat.length <= 0) && chitChatQueue.length >0){    
            cs.bindData(chitChatQueue[0],[],this.people);
        }else{
            cs.bindData(chitChatQueue.length > 0 ? chitChatQueue[0] : null, lastChitChat,this.people);
        }
        O1HD.Canvas().addChild(chatFrame);
    }

}
